import Error from "components/form/Error";
import DrawerButton from "components/form/Franchise-vendor-vehicleallot-drawerbtn";
import DrawerPreviousNext from "components/form/DrawerPreviousNext";
import DrawerCancelNext from "components/form/DrawerCancelNext";
import React, { useState, useEffect } from "react";
import InputArea from "components/form/InputArea";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import InputAreaDate from "components/form/InputAreaDate";
import useFranchiseAlotSubmit from "hooks/useFranchiseAllotSubmit";
import VendorServices from "services/VendorAlotServices";
import Scrollbars from "react-custom-scrollbars-2";
import ActiveButton from "components/form/ActiveButton";
import SelectFranchiseWithBookingId from "components/form/selectFranchiseWithBookingId";
import { setDate } from "date-fns";

const FranchiseAllotDrawer = ({
  id,
  start_date,
  end_date,
  franchise_id,
  franchise_name,
  latest_va_id,
  type,
  modalData,
  tab,
  days,
  package_type,
  faVendorIsAllot,
  is_Franchise_driver_vehicle_alloted,
  franchiseAction,
  clientArrived,
  tripWentOrNot,
}) => {
  const {
    register,
    handleNextStep,
    handlePreviousStep,
    handleSubmit,
    onSubmit,
    tripwent,
    setTrip,
    trigger,
    setChangeReason,
    setEndDate,
    setStartDate,
    setSelectedStartdate,
    errors,
    goToStep,
    selectedFranchise,
    step,
    handlefranchiseChange,
    startDate,
    endDate,
    loading,
  } = useFranchiseAlotSubmit(
    id,
    tab,
    start_date,
    end_date,
    franchise_id,
    latest_va_id,
    package_type,
    faVendorIsAllot,
    franchiseAction,
  );

  const parseDate = (dateStr) => {
    if (!dateStr) {
      return null;
    }
    const [day, month, year] = dateStr.split("-");
    return new Date(`${year}-${month}-${day}`);
  };

  const client_end_date = end_date ? parseDate(end_date) : null;
  const bookingStartDate = parseDate(start_date);
  const bookingEndDate = parseDate(end_date);

  useEffect(() => {
    // Trip Went is not applicable for these package types
    if (
      ["Airport Pickup", "Airport Drop", "Hour Rental"].includes(package_type)
    ) {
      setTrip(false);
      setStartDate(parseDate(start_date));
      return;
    }

    // Outstation, Holiday Package & Oneway:
    // Trip Went is applicable only when days > 1
    if (
      ["Outstation", "Holiday Package", "Oneway"].includes(package_type) &&
      Number(days) <= 1
    ) {
      setTrip(false);
      setStartDate(parseDate(start_date));
      return;
    }

    // Trip was already completed earlier
    if (tripWentOrNot === "1") {
      setTrip(true);
      return;
    }

    // Required conditions are not completed
    if (
      !faVendorIsAllot ||
      !is_Franchise_driver_vehicle_alloted ||
      !clientArrived
    ) {
      setTrip(false);
      setStartDate(parseDate(start_date));
      return;
    }

    // All conditions are satisfied
    setTrip(true);
  }, [
    tripWentOrNot,
    faVendorIsAllot,
    is_Franchise_driver_vehicle_alloted,
    clientArrived,
    package_type,
    days,
    start_date,
  ]);

  const showTripWent =
    franchiseAction === "modify" &&
    !["Airport Pickup", "Airport Drop", "Hour Rental"].includes(package_type) &&
    ((package_type !== "Outstation" &&
      package_type !== "Holiday Package" &&
      package_type !== "Oneway") ||
      Number(days) > 1);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {franchiseAction === "modify" ? (
          <Title title={"Modify Franchise"} />
        ) : (
          <Title title={"Allot Franchise"} />
        )}
      </div>
      <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200  dark:border-gray-600 dark:bg-gray-700 dark:text-gray-400">
        <ul className="flex flex-wrap -mb-px">
          {[
            ...(franchiseAction !== "modify"
              ? [{ tabValue: 1, labelName: "Allot" }]
              : [
                  { tabValue: 1, labelName: "Modify" },
                  { tabValue: 2, labelName: "New Franchise" },
                ]),
          ].map(({ tabValue, labelName }) => (
            <li className="mr-2" key={tabValue}>
              <ActiveButton
                tabValue={tabValue}
                labelName={labelName}
                goToStep={goToStep}
                step={step}
              />
            </li>
          ))}
        </ul>
      </div>

      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-8 scrollbar-hide flex-grow w-full h-full max-h-full pb-40 md:pb-32 lg:pb-32 xl:pb-32">
            {step === 1 && (
              <>
                {franchiseAction !== "modify" && (
                  <>
                    <div className="col-span-8 sm:col-span-4">
                      <SelectFranchiseWithBookingId
                        register={register}
                        label="Franchise"
                        name="franchise"
                        id={id}
                        client_id={id}
                        // franchise_name={franchise_name}
                        // franchise_id={franchise_id}
                        // package_type={package_type}
                        selectedFranchise={selectedFranchise}
                        handlefranchiseChange={handlefranchiseChange}
                      />
                      <Error errorName={errors.franchise_id} />
                    </div>
                    <DrawerButton
                      isSubmitting={loading}
                      id={id}
                      title="Assign"
                      allotname={"Franchise"}
                      Action={franchiseAction}
                    />
                  </>
                )}

                {/* {franchiseAction === "modify" && days > 1 ? ( */}
                {franchiseAction === "modify" ? (
                  <>
                    <div className="grid grid-cols-6 gap-5 mb-3">
                      {/* Trip Went - only required package types */}
                      {showTripWent && (
                        <div className="col-span-6 sm:col-span-6">
                          {tripWentOrNot === "1" ? (
                            <p className="text-sm text-red-600 mb-2">
                              This trip was previously completed. “No” cannot be
                              selected.
                            </p>
                          ) : !faVendorIsAllot ? (
                            <p className="text-sm text-red-600 mb-2">
                              Vendor has not been allotted yet. Trip Went option
                              will be available once the vendor is allotted.
                            </p>
                          ) : !is_Franchise_driver_vehicle_alloted ? (
                            <p className="text-sm text-red-600 mb-2">
                              Vehicle has not been allotted yet. Trip Went
                              option will be available once the vehicle is
                              allotted.
                            </p>
                          ) : !clientArrived ? (
                            <p className="text-sm text-red-600 mb-2">
                              Client has not arrived yet. Trip Went option will
                              be available once the client arrives.
                            </p>
                          ) : null}

                          <LabelArea label={"Trip Went:"} />

                          <div className="flex items-center space-x-4">
                            {/* NO */}
                            <label className="flex items-center text-gray-900 cursor-pointer">
                              <input
                                type="radio"
                                name="tripwent"
                                checked={tripwent === false}
                                className="mr-2"
                                onChange={() => {
                                  if (
                                    tripWentOrNot === "1" ||
                                    !faVendorIsAllot ||
                                    !is_Franchise_driver_vehicle_alloted ||
                                    !clientArrived
                                  ) {
                                    return;
                                  }

                                  setTrip(false);
                                  setStartDate(parseDate(start_date));
                                }}
                              />
                              No
                            </label>

                            {/* YES */}
                            <label className="flex items-center text-gray-900 cursor-pointer">
                              <input
                                type="radio"
                                name="tripwent"
                                checked={tripwent === true}
                                className="mr-2"
                                onChange={() => {
                                  if (
                                    !faVendorIsAllot ||
                                    !is_Franchise_driver_vehicle_alloted ||
                                    !clientArrived
                                  ) {
                                    return;
                                  }

                                  setTrip(true);
                                }}
                              />
                              Yes
                            </label>
                          </div>

                          <Error errorName={errors.tripwent} />
                        </div>
                      )}

                      {/* Reason */}
                      <div className="col-span-6 sm:col-span-6">
                        <LabelArea label={"Reason"} />

                        <InputArea
                          register={register}
                          label="Reason"
                          name="reason"
                          type="text"
                          onChange={(e) => setChangeReason(e.target.value)}
                          placeholder="Enter Reason"
                        />

                        <Error errorName={errors.reason} />

                        {showTripWent && tripwent && (
                          <p className="mt-4 mb-0 text-sm">
                            New franchise start date
                          </p>
                        )}
                      </div>

                      {/* Dates only when Trip Went = Yes */}
                      {showTripWent && tripwent && (
                        <>
                          <div className="col-span-3">
                            <LabelArea label="Start Date" />

                            <InputAreaDate
                              trigger={trigger}
                              register={register}
                              label="Start Date"
                              name="client_start_date"
                              type="date"
                              value={startDate}
                              min={bookingStartDate || new Date(startDate)}
                              max={bookingEndDate}
                              onChange={(date) => setStartDate(date)}
                            />

                            <Error errorName={errors.start_date} />
                          </div>

                          <div className="col-span-3">
                            <LabelArea label="End Date" />

                            <InputAreaDate
                              trigger={trigger}
                              register={register}
                              label="End Date"
                              name="client_end_date"
                              value={endDate}
                              readOnly={true}
                              min={startDate}
                              max={client_end_date}
                            />

                            <Error errorName={errors.end_date} />
                          </div>
                        </>
                      )}

                      <DrawerCancelNext handleNextStep={handleNextStep} />
                    </div>
                  </>
                ) : null}
              </>
            )}

            {step === 2 && franchiseAction === "modify" && (
              <>
                <div className="grid grid-cols-6 gap-3 mb-6">
                  <div className="col-span-6">
                    <LabelArea label={"Franchise Name"} />
                    <SelectFranchiseWithBookingId
                      register={register}
                      label="Franchise"
                      name="franchise_id"
                      selectedFranchise={selectedFranchise}
                      handlefranchiseChange={handlefranchiseChange}
                      client_id={id}
                    />
                    <Error errorName={errors.franchise_id} />
                  </div>

                  {/* <div className="col-span-3"> */}
                  {/* <LabelArea label="Start Date" /> */}
                  {/* <InputAreaDate
                      trigger={trigger}
                      register={register}
                      label="Start Date"
                      name="start_date"
                      type="date"
                      value={tripwent ? new Date(endDate) : new Date(startDate)}
                      value={startDate}
                      onChange={(e) => {
                        setStartDate(e.target.value);
                        // console.log(e.target.value,"hhh")
                      }}
                      onChange={(date) => {
                        if (!date) {
                          setStartDate(null);
                          return;
                        }

                        setStartDate(date);

                        const oldEnd = new Date(date);
                        oldEnd.setDate(oldEnd.getDate() + 1);

                        setEndDate(oldEnd);
                      }}
                      min={new Date(startDate)}
                      max={new Date(endDate)}
                      readOnly={false}
                     // Set to true to disable the input
                    /> */}
                  {/* <Error errorName={errors.start_date} /> */}
                  {/* {console.log(startDate)} */}
                  {/* </div> */}

                  {/* <div className="col-span-3">
                    <LabelArea label="End Date" />
                    <InputAreaDate
                      trigger={trigger}
                      register={register}
                      label="End Date"
                      name="end_date"
                      type="date"
                      placeholder="dd/mm/yyyy"
                      value={new Date(client_end_date)}
                      min={new Date(startDate)}
                      max={new Date(endDate)}
                      readOnly={true} // Set to true to disable the input
                    />
                    <Error errorName={errors.end_date} />
                  </div> */}
                  {/* {console.log(endDate)} */}
                </div>

                <DrawerPreviousNext
                  isSubmitting={loading}
                  handleNextStep={handleNextStep}
                  handlePreviousStep={handlePreviousStep}
                />

                <DrawerButton
                  id={id}
                  isSubmitting={loading}
                  title="Update"
                  allotname={"Franchise"}
                  Action={franchiseAction}
                />
              </>
            )}
          </div>
        </form>
      </Scrollbars>
    </>
  );
};

export default FranchiseAllotDrawer;
